import Reveal from "@/components/Reveal";

const SectionHeading = ({ eyebrow, title, text, dark = true, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <p
          data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="text-xs md:text-sm uppercase tracking-[0.25em] text-electric font-medium mb-6"
        >
          {eyebrow}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`font-display font-extrabold tracking-tighter leading-[1.02] text-4xl md:text-5xl lg:text-6xl ${
          dark ? "text-mist" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base md:text-lg leading-relaxed max-w-xl ${align === "center" ? "mx-auto" : ""} ${dark ? "text-slatec" : "text-navy/70"}`}>
          {text}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
